import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { Modal } from '../../../components/ui/Modal.jsx';
import { Select } from '../../../components/ui/Select.jsx';
import { Input } from '../../../components/ui/Input.jsx';
import { Textarea } from '../../../components/ui/Textarea.jsx';
import { Button } from '../../../components/ui/Button.jsx';
import { logisticsApi } from '../../../api/logistics.js';
import { useStoreOptions } from '../../../hooks/useStoreOptions.js';
import { ApiError } from '../../../api/client.js';
import { t } from '../../../lib/i18n.js';

import { ProductItemPicker } from './ProductItemPicker.jsx';

export function LoadFormModal({ open, onClose }) {
  const queryClient = useQueryClient();
  const { stores } = useStoreOptions({ enabled: open });

  const [storeId, setStoreId] = useState('');
  const [supplier, setSupplier] = useState('');
  const [reference, setReference] = useState('');
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState('');

  useEffect(() => { if (open) { setStoreId(''); setSupplier(''); setReference(''); setItems([]); setNotes(''); } }, [open]);

  const mutation = useMutation({
    mutationFn: () => logisticsApi.createLoad({
      storeId, supplier: supplier || undefined, reference: reference || undefined, notes: notes || undefined,
      items: items.map((i) => ({ productId: i.productId, quantity: Number(i.quantity) || 1, cost: i.cost === '' || i.cost == null ? null : Number(i.cost) }))
    }),
    onSuccess: () => { toast.success('Carico creato (bozza).'); queryClient.invalidateQueries({ queryKey: ['loads'] }); onClose(); },
    onError: (err) => toast.error(err instanceof ApiError ? err.message : t('common.error'))
  });

  const valid = storeId && items.length > 0;

  return (
    <Modal
      open={open}
      onClose={mutation.isPending ? undefined : onClose}
      title="Nuovo carico"
      size="lg"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={mutation.isPending}>{t('common.cancel')}</Button>
          <Button onClick={() => mutation.mutate()} loading={mutation.isPending} disabled={!valid}>Crea bozza</Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <Select label="Negozio" value={storeId} onChange={(e) => setStoreId(e.target.value)}>
            <option value="">Seleziona...</option>
            {stores.map((s) => <option key={s._id} value={s._id}>{s.name}</option>)}
          </Select>
          <Input label="Fornitore" value={supplier} onChange={(e) => setSupplier(e.target.value)} />
          <Input label="Riferimento (DDT)" value={reference} onChange={(e) => setReference(e.target.value)} />
        </div>
        <ProductItemPicker items={items} onChange={setItems} withCost storeId={storeId} />
        <Textarea label="Note" rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} />
        <p className="text-xs text-ink-faint">Il carico viene creato come bozza. Confermalo per aggiornare le giacenze del negozio.</p>
      </div>
    </Modal>
  );
}
